import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Productlifecycle(props) {
    return (
        <div>
            <Container className="h-100 tekrevol_dark_bg p-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
                        <div className="example" data-text="Tailored ">
                            <h2>Tailored To Your Needs For Improved Performance</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
                        <p>Varying needs demand solutions that are custom. Generic systems fail where specific requirements are present. At TekRevol, we tailor our managed mobility services providers to your requirements to get the performance and outcomes you envisioned.</p>
                       <p>We strategically position your business and enable it by providing all the necessary support. From software systems to device configuration to optimize usage, our specialized managed mobility services teams are always ready to work with you closely to build efficient solutions.</p>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Productlifecycle;